import { safeNext } from './phoneAppsPrompt';

export const RESUME_PATH_KEY = 'pik_account_continue';

function local() {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

/** Survives a new tab in the same browser. sessionStorage does not. */
export function rememberResumePath(path) {
  const safe = safeNext(path || '');
  if (!safe) return '';
  const store = local();
  if (store) store.setItem(RESUME_PATH_KEY, safe);
  return safe;
}

export function readResumePath() {
  const store = local();
  if (!store) return '';
  return safeNext(store.getItem(RESUME_PATH_KEY) || '');
}

export function clearResumePath() {
  const store = local();
  if (store) store.removeItem(RESUME_PATH_KEY);
}
